module.exports = "https://static.wmbcdn.com/uniweb/images/c49536b0e4a534fd5d6f463bd1f94816.svg";